import { ThunkAction } from 'redux-thunk'
import store, { RootState } from '..'
import { tankStatisticApi } from '../../apis'
import { TankStatisticEntity, TankStatisticFilter } from '../../models'
import { TankStatisticAction } from '../types'
import {
  SET_TANK_STATISTIC,
  SET_TANK_STATISTIC_FILTER,
  SET_TANK_STATISTIC_LOADED,
} from '../types/tankStatistic'
import { loadProfile } from './authAction'

export const setTankStatistic = (
  tankStatistic: TankStatisticEntity[]
): TankStatisticAction => ({
  type: SET_TANK_STATISTIC,
  payload: tankStatistic,
})

export const setTankStatisticLoaded = (
  loaded: boolean
): TankStatisticAction => ({
  type: SET_TANK_STATISTIC_LOADED,
  payload: loaded,
})

export const setTankStatisticFilter = (
  filter: TankStatisticFilter
): TankStatisticAction => ({
  type: SET_TANK_STATISTIC_FILTER,
  payload: filter,
})

export const loadTankStatistic = (): ThunkAction<
  void,
  RootState,
  null,
  TankStatisticAction
> => {
  return async (dispatch) => {
    try {
      const resp = await tankStatisticApi.getTankStatistic(
        store.getState().tankStatistic.tankStatisticFilter
      )
      dispatch(setTankStatistic(resp.data.data))
    } catch (e) {
      if (e.response && e.response.status && e.response.status === 401) {
        dispatch(loadProfile())
        const resp = await tankStatisticApi.getTankStatistic(
          store.getState().tankStatistic.tankStatisticFilter
        )
        dispatch(setTankStatistic(resp.data.data))
      }
    } finally {
      dispatch(setTankStatisticLoaded(true))
    }
  }
}
